module.exports = __webpack_public_path__ + "media/packs/static/fonts/icon/font-905df3c5f4d5cb1864bb7eec88ba9d6a.eot";